import { $get } from "@/utils/http.js";

export default {
  // home信息
  homeInfo: function() {
    return $get("home");
  },

  // 最近8条交易记录
  transFront8: function() {
    return $get("transFront8");
  },

  // 最近8个区块
  blockFront8: function() {
    return $get("blockFront8");
  },

  // 最近14天交易数据
  transChart14: function() {
    return $get("transChart14");
  },

  // 商品信息
  queryGoods: function(params) {
    return $get("queryGoods", params);
  },

  // 交易信息
  queryTransaction: function(params) {
    return $get("queryTransaction", params);
  },

  // 地址信息
  queryAddress: function(params) {
    return $get("queryAddress", params);
  },

  // 地址交易信息
  queryAddressTxnInfo: function(params) {
    return $get("queryAddressTxnInfo", params);
  },

  // 交易消息数据
  queryTransactionDetail: function(params) {
    return $get("queryTransactionDetail", params);
  },

  // 存证查询
  queryEvidence: function(params) {
    return $get("queryEvidence", params);
  }
};



// WEBPACK FOOTER //
// ./src/api/index.js